"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useFetch_1 = __importDefault(require("../../hooks/useFetch"));
const common_styled_components_1 = require("../common-styled-components");
const SurplusCalculatorResults_1 = __importDefault(require("./SurplusCalculatorResults"));
const ToolLayout_1 = __importDefault(require("../custom/ToolLayout"));
const useMetadata_1 = require("../../hooks/useMetadata");
const useDeepMemo_1 = require("../../hooks/useDeepMemo");
const calculatorUtils_1 = require("../../util/calculatorUtils");
const useMergedCalculatorState_1 = require("../../hooks/useMergedCalculatorState");
const lodash_1 = require("lodash");
const EnergySourceSelectionPanel_1 = __importDefault(require("../custom/EnergySourceSelectionPanel"));
const Icons_1 = require("../custom/Icons");
const auth0_react_1 = require("@auth0/auth0-react");
const apiUtils_1 = require("../../util/apiUtils");
const FleetCalculatorBasicSelectionPanel_1 = __importDefault(require("../fleet-calculator/FleetCalculatorBasicSelectionPanel"));
exports.default = () => {
    const [calculatorParams, setCalculatorParams, removeFuel] = (0, useMergedCalculatorState_1.useMergedCalculatorState)();
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const { isAuthenticated } = (0, auth0_react_1.useAuth0)();
    // Init params from metadata
    (0, react_1.useEffect)(() => {
        if (metadata && calculatorParams === undefined) {
            setCalculatorParams({
                fleet_size: 30,
                emission_allowance_price: 90,
                wind_assisted_propulsion: "1",
                fuels: [(0, calculatorUtils_1.getInitialFossilFuelParam)(metadata)],
                comparison_fuels: [(0, calculatorUtils_1.getInitialComparisonFuelParam)(metadata)],
            });
        }
    }, [metadata]);
    const [calculation, _setUrl, setBody] = (0, useFetch_1.default)("calculator/surplus", undefined, true);
    const [canCalculate] = (0, useDeepMemo_1.useDeepMemo)(() => metadata && calculatorParams
        ? [(0, calculatorUtils_1.canCreateCalculation)(calculatorParams, metadata)]
        : [false], [calculatorParams, metadata]);
    const [validationErrors] = (0, useDeepMemo_1.useDeepMemo)(() => metadata && calculatorParams
        ? [(0, calculatorUtils_1.getCalculationValidationErrors)(calculatorParams, metadata)]
        : [[]], [calculatorParams, metadata]);
    (0, react_1.useEffect)(() => {
        if (canCalculate) {
            setBody(JSON.stringify(calculatorParams));
        }
    }, [calculatorParams, canCalculate]);
    // Data logging
    // console.info("params", calculatorParams);
    if (isAuthenticated) {
        console.info(calculation.status === apiUtils_1.LoaderStatus.Success
            ? "Results: " + JSON.stringify(calculation.data, undefined, 2)
            : "loading");
    }
    // console.info(
    //   metadata ? "Metadata: " + JSON.stringify(metadata, undefined, 2) : "loading"
    // );
    const [languageData] = (0, useFetch_1.default)("calculator/language/en", undefined);
    const texts = languageData.status === apiUtils_1.LoaderStatus.Success
        ? languageData.data
        : undefined;
    const results = !canCalculate && texts ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.P, { style: { height: "600px" }, children: validationErrors && validationErrors.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("ul", { style: { marginLeft: "20px" }, children: validationErrors.map((error, index) => ((0, jsx_runtime_1.jsx)("li", { style: { marginBottom: "8px" }, children: error }, index))) }) })) : ("Select a comparison energy source with a lower intensity than the current energy source.") })) : calculatorParams &&
        calculation &&
        calculation.status === apiUtils_1.LoaderStatus.Success &&
        metadata &&
        texts ? ((0, jsx_runtime_1.jsx)(SurplusCalculatorResults_1.default, { params: calculatorParams, fuelTypes: metadata.fuels, calculation: calculation.data, metadata: metadata, texts: texts })) : (texts && (0, jsx_runtime_1.jsx)(common_styled_components_1.P, { style: { height: "600px" }, children: texts.loading_results }));
    return texts ? ((0, jsx_runtime_1.jsx)(ToolLayout_1.default, { intro: "As regulation around shipping emissions tighten, Ahti calculator is a\n          tool for creating a concrete migration plan towards your new energy\n          source. Select your current energy source below, compare it to a host\n          of new options, and we will plan the fuel mix you need to the year\n          2050.", selections: metadata &&
            calculatorParams &&
            calculatorParams.comparison_fuels &&
            texts ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: "Energy source options" }), calculatorParams.fuels.map((fuel, i) => ((0, jsx_runtime_1.jsx)(EnergySourceSelectionPanel_1.default, { title: `Energy source${calculatorParams.fuels.length > 1 ? ` ${i + 1}` : ""}`, isComparison: false, useFOC: true, initialParams: fuel, metadata: metadata, setParams: setCalculatorParams, fuelIndex: i, texts: texts, removeFuel: calculatorParams.fuels.length > 1
                        ? () => removeFuel(false, i)
                        : undefined }, fuel.fuel_type + i))), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Button, { onClick: (e) => {
                        e.preventDefault();
                        setCalculatorParams({
                            fuels: [
                                ...calculatorParams.fuels,
                                (0, calculatorUtils_1.getInitialSecondFossilFuelParam)(metadata),
                            ],
                        });
                    }, children: [(0, jsx_runtime_1.jsx)(Icons_1.EditIcon, { color: "white" }), (0, jsx_runtime_1.jsx)("span", { children: "Add energy source" })] }), (0, jsx_runtime_1.jsx)(FleetCalculatorBasicSelectionPanel_1.default, { title: "Additional information", metadata: metadata, initialParams: (0, lodash_1.omit)(calculatorParams, "comparison_fuels", "fuels"), setParams: setCalculatorParams, texts: texts })] })) : (texts && (0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: texts.loading_options })), results: results })) : ((0, jsx_runtime_1.jsx)("div", {}));
};
